import React, { useMemo } from "react";
import { useTheme } from "../../hooks/useTheme";
import { DaySchedule } from "../../types/types";
import styles from "./StoreSchedule.module.scss";

type Props = {
  schedule: DaySchedule[];
};

const StoreSchedule = ({ schedule }: Props) => {
  const { theme } = useTheme();

  const sortedSchedule = useMemo(() => {
    if (!schedule?.length) return [];
    return [...schedule].sort((a, b) => a.sequence - b.sequence);
  }, [schedule]);

  // Короткие названия дней
  const dayNames = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

  if (!sortedSchedule.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      {sortedSchedule.map((el) => {
        const dayIndex = el.sequence - 1;
        const dayName = dayIndex >= 0 && dayIndex < dayNames.length 
          ? dayNames[dayIndex] 
          : `${el.sequence}`;

        return (
          <div className={styles.row} key={el.sequence}>
            <span className={styles.day} style={{ color: theme.text }}>
              {dayName}
            </span>
            {el.dayOff ? (
              <span
                className={styles.time}
                style={{ color: theme.textSecondary }}
              >
                вых.
              </span>
            ) : (
              <span
                className={styles.time}
                style={{ color: theme.textSecondary }}
              >
                {el.from}–{el.to}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StoreSchedule;